import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { formatApiError } from "@/lib/api";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ shop_name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form.email, form.password, form.shop_name);
      toast.success("Compte créé — 5 crédits offerts pour commencer");
      nav("/dashboard");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Erreur d'inscription");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-zinc-950 flex items-center justify-center px-4">
      <div className="w-full max-w-md border border-zinc-800 p-10">
        <Link to="/" className="font-display text-2xl font-bold tracking-tight block mb-2">
          mixo<span className="text-red-500"> </span>vap
        </Link>
        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500 mb-8">Créer un compte</div>
        <form onSubmit={submit} className="space-y-5">
          <Field label="Nom de la boutique" testid="register-shop">
            <Input required value={form.shop_name} onChange={(e) => setForm({ ...form, shop_name: e.target.value })}
              className="rounded-none bg-zinc-900 border-zinc-800 focus-visible:ring-1 focus-visible:ring-red-500 focus-visible:ring-offset-0 focus-visible:border-red-500" data-testid="register-shop-input" />
          </Field>
          <Field label="Email" testid="register-email">
            <Input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="rounded-none bg-zinc-900 border-zinc-800 focus-visible:ring-1 focus-visible:ring-red-500 focus-visible:ring-offset-0 focus-visible:border-red-500" data-testid="register-email-input" />
          </Field>
          <Field label="Mot de passe (min. 6 caractères)" testid="register-password">
            <Input required type="password" minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
              className="rounded-none bg-zinc-900 border-zinc-800 focus-visible:ring-1 focus-visible:ring-red-500 focus-visible:ring-offset-0 focus-visible:border-red-500" data-testid="register-password-input" />
          </Field>
          <Button data-testid="register-submit" disabled={loading} className="w-full bg-red-500 hover:bg-red-600 rounded-none font-medium">
            {loading ? "Création…" : "Créer mon compte"}
          </Button>
        </form>
        <div className="mt-6 text-sm text-zinc-500 text-center">
          Déjà inscrit ?{" "}
          <Link to="/login" data-testid="register-login-link" className="text-red-500 hover:text-red-400">Se connecter</Link>
        </div>
      </div>
    </div>
  );
}

function Field({ label, children }) {
  return (
    <div>
      <label className="block text-xs font-mono uppercase tracking-widest text-zinc-500 mb-2">{label}</label>
      {children}
    </div>
  );
}
